// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyDF9R5xWNkgNPV9FAMDVJhpX7jT6Yp8pq8",
//   authDomain: "hondenschool-81457.firebaseapp.com",
//   projectId: "hondenschool-81457",
//   storageBucket: "hondenschool-81457.firebasestorage.app",
//   messagingSenderId: "257584076307",
//   appId: "1:257584076307:web:3f7afecc4d110cd87711e6",
// };

const firebaseConfig = {
  apiKey: "AIzaSyBts7tPmxDw2C6JtB9iTcdWk0Q53jxAliw",
  authDomain: "willy-woef.firebaseapp.com",
  projectId: "willy-woef",
  storageBucket: "willy-woef.firebasestorage.app",
  messagingSenderId: "627053036340",
  appId: "1:627053036340:web:dbb9b63d8ca2d0f2cc9b61",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

auth.languageCode = "nl";

export { auth };
